import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export const GPS_EVERY = 10000;

export function agoText(at) {
  const s = Math.max(0, Math.round((Date.now() - new Date(at).getTime()) / 1000));
  if (s < 15) return "atualizado agora";
  if (s < 60) return `atualizado há ${s} s`;
  return `atualizado há ${Math.round(s / 60)} min`;
}

export function useCourierGps(url, active) {
  const [st, setSt] = useState("off");
  const latest = useRef(null);
  useEffect(() => {
    if (!active) {
      setSt("off");
      return undefined;
    }
    if (!navigator.geolocation) {
      setSt("unsupported");
      return undefined;
    }
    setSt("waiting");
    latest.current = null;
    let sent = null;
    let lock = null;
    let stopped = false;
    const push = () => {
      const p = latest.current;
      if (!p || p === sent || stopped) return;
      sent = p;
      api.post(url, { lat: p.coords.latitude, lng: p.coords.longitude, accuracy: Math.min(p.coords.accuracy || 0, 100000) })
        .then((r) => { if (r.data?.tracking === false) { stopped = true; setSt("done"); } })
        .catch(() => {});
    };
    const id = navigator.geolocation.watchPosition((p) => {
      const first = !latest.current;
      latest.current = p;
      setSt((s) => (s === "done" ? s : "on"));
      if (first) push();
    }, (e) => setSt((s) => (e.code === 1 ? "denied" : s === "on" ? s : "waiting")), { enableHighAccuracy: true, maximumAge: 5000, timeout: 30000 });
    const timer = setInterval(push, GPS_EVERY);
    const wake = () => {
      if (document.visibilityState === "visible") navigator.wakeLock?.request("screen").then((l) => { lock = l; }).catch(() => {});
    };
    wake();
    document.addEventListener("visibilitychange", wake);
    return () => {
      navigator.geolocation.clearWatch(id);
      clearInterval(timer);
      document.removeEventListener("visibilitychange", wake);
      if (lock) lock.release().catch(() => {});
    };
  }, [url, active]);
  return st;
}
